import React, { useState, useEffect } from 'react';
import { FaBirthdayCake, FaCheckCircle } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [isVerified, setIsVerified] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (verified === 'true') {
      setIsVerified(true);
    } else {
      setShowModal(true);
    }
  }, []);

  const handleVerify = (isOver18: boolean) => {
    if (isOver18) {
      localStorage.setItem('ageVerified', 'true');
      setIsVerified(true);
      setShowModal(false);
    } else {
      alert('Vous devez avoir 18 ans ou plus pour accéder à ce site.');
      window.location.href = 'https://www.joueurs-info-service.fr/';
    }
  };

  if (!showModal || isVerified) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm">
      <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-md mx-4 shadow-2xl animate-fade-in">
        <div className="text-center mb-6">
          <FaBirthdayCake className="mx-auto text-6xl text-yellow-400 mb-4" />
          <h2 className="text-3xl font-bold text-white mb-2">Vérification d'âge</h2>
          <p className="text-gray-400">
            Vous devez avoir 18 ans ou plus pour accéder à ce site
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <p className="text-sm text-gray-300 text-center">
            Ce site contient des informations sur les services de paris sportifs. En continuant,
            vous confirmez que vous avez l'âge légal pour parier dans votre juridiction.
          </p>
          <div className="bg-dark-surface rounded-lg p-4 border border-dark-border">
            <p className="text-xs text-gray-400 text-center">
              <strong className="text-yellow-400">Jeu responsable :</strong> Si vous pensez
              avoir un problème de jeu, veuillez visiter{' '}
              <a
                href="https://www.joueurs-info-service.fr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-400 hover:underline"
              >
                Joueurs-info-service.fr
              </a>
            </p>
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            onClick={() => handleVerify(false)}
            className="flex-1 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors font-semibold"
          >
            J'ai moins de 18 ans
          </button>
          <button
            onClick={() => handleVerify(true)}
            className="flex-1 px-6 py-3 bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-dark-bg rounded-lg transition-all font-semibold flex items-center justify-center space-x-2"
          >
            <FaCheckCircle />
            <span>J'ai 18 ans ou plus</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

